import { TournamentStatus, TournamentType } from '@repo/database/src/types';
import type { TournamentTicket } from '@repo/database/src/types';
import type { TournamentUpdateInput } from '@repo/database/src/types';

import { BlindStructureWithLevels } from './blind-structure.dto';
import { TournamentPayoutStructureDto } from './payout-structure.dto';

export interface TournamentUpdateDto extends Partial<TournamentUpdateInput> {
  payoutStructureId?: string;
  blindStructureId?: string;
}

export interface TournamentInfoDto {
  // Tournament info
  id: string;
  templateId: string;
  name: string;
  game: string;
  tableSize: number;
  tournamentType: TournamentType;
  status: TournamentStatus;
  startTime: Date | null | undefined;
  endTime: Date | null;
  lateRegistrationTime: Date | null;
  buyIn: number;
  bountyAmount?: number;
  fee: number;
  totalBuyin: number;
  startingChips: number;
  blindInterval: number;
  payoutDistributionPercentage: number;
  category: string;
  bettingStructure: string;
  minPlayers: number;
  maxPlayers: number;
  tableId?: string | null;
  blindStructureId?: string;
  blindStructure?: BlindStructureWithLevels | null;
  payoutStructureId?: string;
  payoutStructure?: TournamentPayoutStructureDto | null;
  lateRegistrationUpToLevel?: number | undefined;
  levelEndAt: Date | null;
  isPublic: boolean;
  deletedAt: Date | null;
  registrationOpenTime: Date | null;
  // Tournament stats
  entries: number;
  playersRemaining: number;
  currentLevel: number;
  blindLevel: TournamentBlindLevelDto | null;
  guaranteedPrize: number;
  overlay: number;
  prizePool: number;
  maxReentries: number;
  maxAddons: number;
  finishedAt: Date | null;
  blindIntervalInMinutes: number;
  breakDurationInMinutes: number;
  breakStartMinute: number;

  // Timebank configuration
  startingTimebankInSeconds?: number;
  timebankRefillAmountInSeconds?: number;
  timebankRefillEveryLevels?: number;
  startingDisconnectionTimebankInSeconds?: number;

  // Tournament customization
  icon?: string | null;
  titleColor?: string | null;
  lobbyIcons?: string[];

  url: string | null;
  minimumTierRequired: string | null;
  registrationOpenPeriodInMinutes?: number;
  recurringScheduleId?: string | null;

  contractAddress?: string | null;
  cancellationReason: string | null;

  myPosition: number | null;
  myRegularPrize: number | null;
  myPrizeTicket?: TournamentTicket | null;
  myTournamentDollarsAwarded?: number;

  parentTournament?: TournamentInfoDto | null;
  satelliteTournaments?: string[] | null;
  ticketPrizePool?: number;
  tournamentDollarsPrizePool?: number;
}

export interface TournamentBlindLevelDto {
  levelNumber: number;
  smallBlind: number | null;
  bigBlind: number | null;
  ante: number | null;
  bringIn: number | null;
  smallBet: number | null;
  bigBet: number | null;
}
